// @ts-nocheck — TODO(flow-migration): fix types incrementally
import { SubscribeView } from 'Views/newsletter/subscription/SubscriptionView';
export default SubscribeView;
